export const ACTION_TYPES = {
  SET_HISTORY_PATHNAME: 'history/SET_HISTORY_PATHNAME',
};

export const setHistoryPathName = ({ pathname }) => ({
  type: ACTION_TYPES.SET_HISTORY_PATHNAME,
  payload: { pathname },
});
